"use client";

import { Provider } from "react-redux";
import { useEffect, useRef } from "react";
import { makeStore } from "@/store";
import { initializeCarts } from "@/store/slices/cartSlice";
import { initializeCustomer } from "@/store/slices/customerSlice";

function StoreBootstrap({ store }) {
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    async function initializeStorefront() {
      // Restore cart IDs first so a returning signed-in customer can claim
      // any existing Grocery and Takeout carts after the session is restored.
      await store.dispatch(initializeCarts());
      await store.dispatch(initializeCustomer());
    }

    initializeStorefront();
  }, [store]);

  return null;
}

export default function StoreProvider({ children }) {
  const storeRef = useRef(null);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return (
    <Provider store={storeRef.current}>
      <StoreBootstrap store={storeRef.current} />
      {children}
    </Provider>
  );
}
